var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showDialog },
          on: {
            "update:mdActive": function($event) {
              _vm.showDialog = $event
            },
            "update:md-active": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("md-dialog-title", [_vm._v("Search Members")]),
          _vm._v(" "),
          _c(
            "md-field",
            { staticClass: "searcher", attrs: { "md-clearable": "" } },
            [
              _vm.section !== "members"
                ? _c("label", [_vm._v("Existing member or email")])
                : _c("label", [_vm._v("Existing member or new email")]),
              _vm._v(" "),
              _c("md-input", {
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.quickSearch.apply(null, arguments)
                  },
                  input: function($event) {
                    return _vm.sanitizeSearchText($event)
                  }
                },
                model: {
                  value: _vm.searchText,
                  callback: function($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.searchResults.length > 0
            ? _c(
                "multi-member-picker",
                {
                  attrs: {
                    members: _vm.searchResults,
                    selected: _vm.selected,
                    admin: _vm.selectionProp,
                    iconName: _vm.iconName
                  },
                  on: { changed: _vm.updateSelected }
                },
                [_vm._v("Advisors goes here...")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _vm.editAsk
                ? [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-primary",
                        attrs: { disabled: _vm.selected.length <= 0 },
                        on: {
                          click: function($event) {
                            return _vm.choose()
                          }
                        }
                      },
                      [_vm._v("save")]
                    )
                  ]
                : [
                    _vm.searchResults.length > 0 && _vm.section == "members"
                      ? _c(
                          "md-button",
                          {
                            staticClass: "md-primary",
                            attrs: { disabled: _vm.selected.length <= 0 },
                            on: {
                              click: function($event) {
                                return _vm.choose()
                              }
                            }
                          },
                          [_vm._v("Choose")]
                        )
                      : (_vm.section == "members" || _vm.section == "addAsk") &&
                        _vm.emailPattern.test(_vm.searchText) &&
                        _vm.searchResults.length == 0
                      ? _c(
                          "md-button",
                          {
                            staticClass: "md-primary",
                            on: {
                              click: function($event) {
                                return _vm.addMember()
                              }
                            }
                          },
                          [_vm._v("Add New Member")]
                        )
                      : _c(
                          "md-button",
                          {
                            staticClass: "md-primary",
                            attrs: { disabled: _vm.selected.length <= 0 },
                            on: {
                              click: function($event) {
                                return _vm.choose()
                              }
                            }
                          },
                          [_vm._v("Choose")]
                        )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "picker-icon picker-name",
          on: {
            click: function($event) {
              _vm.showDialog = true
            }
          }
        },
        [
          _vm.editAsk
            ? [
                _c("font-awesome-icon", {
                  staticClass: "small-icon",
                  attrs: { icon: "pencil-alt" }
                })
              ]
            : [
                _c("font-awesome-icon", {
                  staticClass: "small-icon",
                  attrs: { icon: "plus-circle" }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.iconName))])
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e05d810", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e05d810","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberPicker.vue
// module id = null
// module chunks = 